<template>
  <MetricCard
    apiEndpoint="/google-ads/conversion-rate"
    metricName="CONVERSION RATE"
    :formatData="formatCR"
    srcName="Google Ads"
  />
</template>

<script setup>
import MetricCard from '@/components/MetricCard.vue';

const formatCR = (data) => data.data + '%';
</script>
